import Button from '@new-components/atoms/MuiButton';
import MuiBox from '@new-components/atoms/MuiBox';
 export interface UnitOptions {
  label: string;
  key: string;
}
export type CommunityUnitOptionsProps = {
  /**
   * list of options
   */
  options: UnitOptions[];
  /**
   * handle the click of options
   */
  handleOptionClick: (value: string) => void;
  /**
   * selected option
   */
  selectedOptions: string[];
};
export function CommunityPropertyFilter(props: CommunityUnitOptionsProps) {
  return (
    <MuiBox sx={{display: 'flex', gap: '8px'}}>
      {props.options.map((item) => {
        const isActive = props.selectedOptions.includes(item.key);
        return (
          <Button
            size="medium"
            variant="outlined"
            sx={{
              height: '40px',
              padding: '0px 20px',
              color: '#2d2d2d',
              border: '1px solid #babac8',
              backgroundColor: isActive? '#dddddd': '',
              '&:hover': {
                border: '1px solid #babac8',
              }
            }}
            key={item.key}
            onClick={() => props.handleOptionClick(item.key)}>
               {item.label}
          </Button>
        );
      })}
    </MuiBox>
  );
}